var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*! torrent-discovery. MIT License. WebTorrent LLC <https://webtorrent.io/opensource> */
var debug = require('debug')('torrent-discovery');

var DHT = require('bittorrent-dht/client'); // empty object in browser


var EventEmitter = require('events').EventEmitter;

var parallel = require('run-parallel');

var Tracker = require('bittorrent-tracker/client');

var LSD = require('bittorrent-lsd');

var Discovery = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Discovery, _EventEmitter);

  var _super = _createSuper(Discovery);

  function Discovery(opts) {
    var _this;

    _classCallCheck(this, Discovery);

    _this = _super.call(this);
    if (!opts.peerId) throw new Error('Option `peerId` is required');
    if (!opts.infoHash) throw new Error('Option `infoHash` is required');
    if (!process.browser && !opts.port) throw new Error('Option `port` is required');
    _this.peerId = typeof opts.peerId === 'string' ? opts.peerId : opts.peerId.toString('hex');
    _this.infoHash = typeof opts.infoHash === 'string' ? opts.infoHash.toLowerCase() : opts.infoHash.toString('hex');
    _this._port = opts.port; // torrent port

    _this._userAgent = opts.userAgent; // User-Agent header for http requests

    _this.destroyed = false;
    _this._announce = opts.announce || [];
    _this._intervalMs = opts.intervalMs || 15 * 60 * 1000;
    _this._trackerOpts = null;
    _this._dhtAnnouncing = false;
    _this._dhtTimeout = false;
    _this._internalDHT = false; // is the DHT created internally?

    _this._onWarning = function (err) {
      _this.emit('warning', err);
    };

    _this._onError = function (err) {
      _this.emit('error', err);
    };

    _this._onDHTPeer = function (peer, infoHash) {
      if (infoHash.toString('hex') !== _this.infoHash) return;

      _this.emit('peer', "".concat(peer.host, ":").concat(peer.port), 'dht');
    };

    _this._onTrackerPeer = function (peer) {
      _this.emit('peer', peer, 'tracker');
    };

    _this._onTrackerAnnounce = function () {
      _this.emit('trackerAnnounce');
    };

    _this._onLSDPeer = function (peer, infoHash) {
      _this.emit('peer', peer, 'lsd');
    };

    var createDHT = function createDHT(port, opts) {
      var dht = new DHT(opts);
      dht.on('warning', _this._onWarning);
      dht.on('error', _this._onError);
      dht.listen(port);
      _this._internalDHT = true;
      return dht;
    };

    if (opts.tracker === false) {
      _this.tracker = null;
    } else if (opts.tracker && typeof opts.tracker === 'object') {
      _this._trackerOpts = Object.assign({}, opts.tracker);
      _this.tracker = _this._createTracker();
    } else {
      _this.tracker = _this._createTracker();
    }

    if (opts.dht === false || typeof DHT !== 'function') {
      _this.dht = null;
    } else if (opts.dht && typeof opts.dht.addNode === 'function') {
      _this.dht = opts.dht;
    } else if (opts.dht && typeof opts.dht === 'object') {
      _this.dht = createDHT(opts.dhtPort, opts.dht);
    } else {
      _this.dht = createDHT(opts.dhtPort);
    }

    if (_this.dht) {
      _this.dht.on('peer', _this._onDHTPeer);

      _this._dhtAnnounce();
    }

    if (opts.lsd === false || typeof LSD !== 'function') {
      _this.lsd = null;
    } else {
      _this.lsd = _this._createLSD();
    }

    return _this;
  }

  _createClass(Discovery, [{
    key: "updatePort",
    value: function updatePort(port) {
      var _this2 = this;

      if (port === this._port) return;
      this._port = port;
      if (this.dht) this._dhtAnnounce();

      if (this.tracker) {
        this.tracker.stop();
        this.tracker.destroy(function () {
          _this2.tracker = _this2._createTracker();
        });
      }
    }
  }, {
    key: "complete",
    value: function complete(opts) {
      if (this.tracker) {
        this.tracker.complete(opts);
      }
    }
  }, {
    key: "destroy",
    value: function destroy(cb) {
      var _this3 = this;

      if (this.destroyed) return;
      this.destroyed = true;
      clearTimeout(this._dhtTimeout);
      var tasks = [];

      if (this.tracker) {
        this.tracker.stop();
        this.tracker.removeListener('warning', this._onWarning);
        this.tracker.removeListener('error', this._onError);
        this.tracker.removeListener('peer', this._onTrackerPeer);
        this.tracker.removeListener('update', this._onTrackerAnnounce);
        tasks.push(function (cb) {
          _this3.tracker.destroy(cb);
        });
      }

      if (this.dht) {
        this.dht.removeListener('peer', this._onDHTPeer);
      }

      if (this._internalDHT) {
        this.dht.removeListener('warning', this._onWarning);
        this.dht.removeListener('error', this._onError);
        tasks.push(function (cb) {
          _this3.dht.destroy(cb);
        });
      }

      if (this.lsd) {
        this.lsd.removeListener('warning', this._onWarning);
        this.lsd.removeListener('error', this._onError);
        this.lsd.removeListener('peer', this._onLSDPeer);
        tasks.push(function (cb) {
          _this3.lsd.destroy(cb);
        });
      }

      parallel(tasks, cb); // cleanup

      this.dht = null;
      this.tracker = null;
      this.lsd = null;
      this._announce = null;
    }
  }, {
    key: "_createTracker",
    value: function _createTracker() {
      var opts = Object.assign({}, this._trackerOpts, {
        infoHash: this.infoHash,
        announce: this._announce,
        peerId: this.peerId,
        port: this._port,
        userAgent: this._userAgent
      });
      var tracker = new Tracker(opts);
      tracker.on('warning', this._onWarning);
      tracker.on('error', this._onError);
      tracker.on('peer', this._onTrackerPeer);
      tracker.on('update', this._onTrackerAnnounce);
      tracker.setInterval(this._intervalMs);
      tracker.start();
      return tracker;
    }
  }, {
    key: "_dhtAnnounce",
    value: function _dhtAnnounce() {
      var _this4 = this;

      if (this._dhtAnnouncing) return;
      debug('dht announce');
      this._dhtAnnouncing = true;
      clearTimeout(this._dhtTimeout);
      this.dht.announce(this.infoHash, this._port, function (err) {
        _this4._dhtAnnouncing = false;
        debug('dht announce complete');
        if (err) _this4.emit('warning', err);

        _this4.emit('dhtAnnounce');

        if (!_this4.destroyed) {
          _this4._dhtTimeout = setTimeout(function () {
            _this4._dhtAnnounce();
          }, _this4._intervalMs + Math.floor(Math.random() * _this4._intervalMs / 5));
          if (_this4._dhtTimeout.unref) _this4._dhtTimeout.unref();
        }
      });
    }
  }, {
    key: "_createLSD",
    value: function _createLSD() {
      var opts = Object.assign({}, {
        infoHash: this.infoHash,
        peerId: this.peerId,
        port: this._port
      });
      var lsd = new LSD(opts);
      lsd.on('warning', this._onWarning);
      lsd.on('error', this._onError);
      lsd.on('peer', this._onLSDPeer);
      lsd.start();
      return lsd;
    }
  }]);

  return Discovery;
}(EventEmitter);

module.exports = Discovery;